import React, { useState } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    Button,
    Divider,
    TextField
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import KeywordDesignPopup from "./KeywordDesignPopup";
import BrowsePathPopup from "./BrowsePathPopup";
import { ConnectWithoutContact } from "@mui/icons-material";
import {ConnectingToGIT} from "../../../services/webServices";

function RobotFileTempletPopUp({ open, handleClose, framework }) {
    const navigate = useNavigate(); // For navigating to the landing page
    const [showPopup, setShowPopup] = useState(false);
     const [url, setUrl] = useState("");
      const [user, setUser] = useState("");
      const [apiToken, setApiToken] = useState("");
      const [branch, setBranch] = useState("");
      const [formData, setFormData] = useState({
        url: "",    
        user: "",
        apiToken: "",
        branch: "",
      });



    // Function to navigate to the landing page
  

    const handleChange = (field) => (e) => {
        const value = e.target.value;
      
        // Update formData
        setFormData((prev) => ({ ...prev, [field]: value }));
      
        // Update individual state variables
        switch (field) {
          case "url":
            setUrl(value);
            break;
          case "user":
            setUser(value);
            break;
          case "apiToken":
            setApiToken(value);
            break;
          case "branch":
            setBranch(value);
            break;
          default:
            break;
        }
      };

    const handleConnect = async() => {   
        console.log("Form Data:", formData);
        navigate("/dashboard/test-automation/robot-framework", { state: { framework: framework } });
         // Log the form data
        // const response = await ConnectingToGIT(formData);
        // if (response) {
        //     console.log("Response:", response);

            // Handle the response as needed
     // Navigate to the landing page after successful connection
        

    }

  
    return (
        <>
            <Dialog
                open={open}
               // onClose={handleClose}
                PaperProps={{
                    sx: {
                        borderRadius: "8px",
                        minWidth: "400px",
                        padding: "20px",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        //   fontWeight: "bold",
                        fontSize: "16px",
                        paddingBottom: "10px",
                        fontFamily: "Roboto, sans-serif",
                        marginBottom:'10px'
                    }}
                >
                Git credentials
                  <IconButton
                                onClick={handleClose} // Close dialog when clicked
                                sx={{
                                  position: "absolute", // Position the close button absolutely
                                  top: "8px", // Adjust distance from top
                                  right: "8px", // Adjust distance from right
                                }}
                              >
                                <CloseIcon />
                              </IconButton>
                </DialogTitle>

                <DialogContent sx={{ paddingBottom: "20px" }}>
                    <form>
                   
                     <TextField
                                      fullWidth
                                      label="Repository URL"
                                      variant="outlined"
                                      margin="normal"
                                      value={url}
                                      onChange={handleChange("url")}
                                    />
                                    <TextField
                                      fullWidth
                                      label="User Name"
                                      variant="outlined"
                                      margin="normal"
                                      value={user}
                                      onChange={handleChange("user")}
                                    />
                                    <TextField
                                      fullWidth
                                      label="GIT API Token"
                                      variant="outlined"
                                      margin="normal"
                                      //type="password"
                                      value={apiToken}
                                      onChange={handleChange("apiToken")}
                                    />
                                     <TextField
                                      fullWidth
                                      label="Branch"
                                      variant="outlined"
                                      margin="normal"
                                      value={branch}
                                      onChange={handleChange("branch")}
                                    />
                                    </form>
                </DialogContent>

                <Divider />

                <DialogActions sx={{ justifyContent: "flex-end", padding: "10px 24px" }}>
                    
                    <Button
                        onClick={handleConnect} // Use onClose prop to close the dialog
                        sx={{
                            textTransform: "none",
                            // fontWeight: "bold",
                            fontSize: "16px",
                            fontFamily: "Roboto, sans-serif",
                            color: "#49A3FF", // Blue text by default
                            // border: "1px solid #1976d2", // Blue border
                            backgroundColor: "white", // White background
                            "&:hover": {
                                backgroundColor: "#49A3FF", // Blue background on hover
                                color: "white", // White text on hover
                            },
                            "&:active": {
                                backgroundColor: "#49A3FF", // Darker blue when clicked
                                color: "white",
                            },
                            display: "flex",
                            alignItems: "center",
                            padding: "5px 15px",
                        }}
                    >
                        Connect To Git
                    </Button>

                  
                </DialogActions>
            </Dialog>
            {/* <BrowsePathPopup
                open={showPopup}
                //handleClose={handleClosePopup}
                text1={"Upload Robot File Template"}
                text2={"Browse Robot Framework Template from your system to upload"}
            /> */}
        </>
    );
}

export default RobotFileTempletPopUp;
